import Template from '../../interaction/template'
import Modal from '../../interaction/modal'
import Controller from '../controller'
import Utils from '../../utils/utils'
import Manifest from '../manifest'
import Device from './device'
import Platform from '../platform'

function show(template_name){
    let enabled = Controller.enabled().name

    Modal.open({
        title: '',
        html: Template.get(template_name),
        onBack: ()=>{
            Modal.close()

            Controller.toggle(enabled)
        }
    })
}

function account(){
    let enabled = Controller.enabled().name
    let html    = $(Template.js('account_none'))
    let bot     = Manifest.bot_username
    let qr_url  = bot ? 'https://t.me/' + bot : 'https://' + Manifest.cub_site

    if(Platform.tv()) html.addClass('layer--' + (Platform.mouse() ? 'wheight' : 'height'))
    else html.addClass('account-modal-split--mobile')

    let code = html.find('.account-modal-split__qr-code')
    let img  = html.find('.account-modal-split__qr-img')

    Utils.qrcode(qr_url, code, ()=>{
        code.remove()
        img.removeClass('hide').addClass('loaded')
    })

    Modal.open({
        title: '',
        html: $(html),
        size: Platform.tv() ? 'full' : 'medium',
        scroll: {
            nopadding: true
        },
        onSelect: ()=>{
            Modal.close()

            Device.login(()=>{
                Controller.toggle(enabled)
            })
        },
        onBack: ()=>{
            Modal.close()

            Controller.toggle(enabled)
        }
    })
}

function limited(){
    show('account_limited')
}

function premium(){
    let enabled = Controller.enabled().name
    let html    = $(Template.js('account_premium'))
    let bot     = Manifest.bot_username

    if(bot){
        html.find('.account-modal-split__bot-link').text('@' + bot).attr('href', 'https://t.me/' + bot)
    }

    if(Platform.tv()) html.addClass('layer--' + (Platform.mouse() ? 'wheight' : 'height'))
    else html.addClass('account-modal-split--mobile')

    let qr_url = bot ? 'https://t.me/' + bot : 'https://' + Manifest.cub_site
    let code   = html.find('.account-modal-split__qr-code')
    let img    = html.find('.account-modal-split__qr-img')

    Utils.qrcode(qr_url, code, ()=>{
        code.remove()
        img.removeClass('hide').addClass('loaded')
    })

    Modal.open({
        title: '',
        html: $(html),
        size: Platform.tv() ? 'full' : 'medium',
        scroll: {
            nopadding: true
        },
        onBack: ()=>{
            Modal.close()

            Controller.toggle(enabled)
        }
    })
}


export default {
    account,
    limited,
    premium
}